// extracted by mini-css-extract-plugin
export default {"c-loading-spinner":"_jVgcJ","c-loading-spinner__spinner":"_IOZBb"};